<template>
  <div class="wrapper-content">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WrapperContent'
}
</script>

<style lang="scss" scoped>
.wrapper-content {
  position: relative;
  background: #ffffff;
  border: 1px solid #ebebeb;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
  border-radius: 25px;
  padding: 35px 30px;
  margin-top: 42px;

  & + .wrapper-content {
    margin-top: 40px;
  }
}
</style>
